<template>
    <breadCrumbs title="Raised Style" main="Buttons" title1="Raised Style" />
    <div class="container-fluid">
            <div class="row">
              <div class="col-sm-12 text-start">
                  <raised/>
                  <raised2/>
                  <raised3/>
              </div>
            </div>
         </div>
</template>
<script>
import raised from "./raisedPage.vue"
import raised2 from "./raised2Page.vue"
import raised3 from "./raised3Page.vue"
export default {
    components:{
        raised,
        raised2,
        raised3
    }
}
</script>